export { useNavigateToEditProductDetails } from './useNavigateToEditProductDetails';
